<template>

  <header class="flex flex-col items-center justify-center bg-gray-50">
    
    <div class="flex flex-col items-center py-0">
      <img class="object-contain w-full" src="@/assets/logo.png" />
    </div>      

    <div class="flex flex-col items-center">

      <div class="flex flex-col md:flex-row gap-1 md:gap-4 py-8">
        <router-link to="/" class="px-5 py-2 border border-black bg-transparent text-black font-semibold hover:bg-black hover:text-white rounded-md" >
          <i class="pi pi-check mr-2"></i>SOY INVITADO
        </router-link>
        <router-link to="/prensa" class="px-5 py-2 border border-black bg-transparent text-black font-semibold hover:bg-black hover:text-white rounded-md" >
          <i class="pi pi-check mr-2"></i>SOY PRENSA
        </router-link>
        <router-link to="/credenciales" class="px-5 py-2 border border-black bg-transparent text-black font-semibold hover:bg-black hover:text-white rounded-md" >
          <i class="pi pi-check mr-2"></i>YA ME ACREDITÉ
        </router-link>

      </div>

    </div>
    <div class="w-full py-1" style="background-color: #ababab;"></div>    

  </header>


</template>

<script>
import VueScrollTo from 'vue-scrollto';

export default {
  methods: {
    scrollToForm() {
      VueScrollTo.scrollTo('#formulario', 500, {
        easing: 'ease-in-out',
      });
    },
  },  
}

</script>